module.exports = __webpack_public_path__ + "img/bg4.de2782aa.jpg";